// src/components/shared/Button.js
import styled from 'styled-components';

const Button = styled.button`
  padding: ${(props) => props.size ? props.theme.buttonSizes[props.size] : props.theme.buttonSizes.medium};
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.textPrimary};
  border: none;
  border-radius: ${(props) => props.theme.borderRadius};
  font-size: ${(props) => props.theme.typography.fontSize.medium};
  font-weight: ${(props) => props.theme.typography.fontWeight.medium};
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #e58e18;  // Slightly darken for hover effect
  }

  &:focus {
    outline: 2px solid ${(props) => props.theme.colors.primary};
    outline-offset: 2px;
  }

  &:disabled {
    background-color: ${(props) => props.theme.colors.surface};
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export default Button;